import React, { useState, useEffect, useRef } from "react";
import "./styles.css";
import backIcon from "../../../static/img/back.svg";
import settingsIcon from "../../../static/img/settings.svg";
import profilePlaceHolder from "../../../static/img/profilePlaceHolder.svg";
import instagramIconGrey from "../../../static/img/instagramIconGrey.svg";
import forward from "../../../static/img/forward.svg";
import improov from "../../../static/img/improov.svg";
import miniCalendar from "../../../static/img/miniCalendar.svg";
import logoutIcon from "../../../static/img/logoutIcon.svg";
import Footer from "../footer/footer";
import { useNavigate } from "react-router-dom";
import { logOut, updateUserPhoto } from "../../../services/authApi";
import { getUserInfo } from "../../../services/deportistaApi";
import { getUserId } from "../../../services/utilsApi";
import LoadingScreen from "../../../static/assets/loadingScreen/loadingScreen";
import CuadroTexto from "../../../static/assets/cuadroTexto/cuadroTexto";
import ImageCropper from "../../../utils/ImageCropper";

const Perfil = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [userData, setUserData] = useState({
    nombre: "",
    apellido: "",
    foto: "default",
    objetivo: "",
    entrenador: null,
    celular: "",
    instagram: "",
  });

  const [imageSrc, setImageSrc] = useState(null);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);

  const [showAvatarOptions, setShowAvatarOptions] = useState(false);
  const [viewImageModal, setViewImageModal] = useState(false);

  useEffect(() => {
    const blocked = isCropModalOpen || viewImageModal;
    document.body.classList.toggle("modal-open", blocked);
    return () => document.body.classList.remove("modal-open");
  }, [isCropModalOpen, viewImageModal]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data: health } = await getUserId();
        const { data: resp } = await getUserInfo(health.user_id);
        const perfil = resp.perfil;
        setUserData({
          nombre: perfil.nombre,
          apellido: perfil.apellido,
          foto: perfil.foto || "",
          objetivo: perfil.objetivo,
          entrenador: perfil.entrenador || null,
          celular: perfil.celular || "",
          instagram: perfil.instagram || "",
          fecha_creacion_cuenta: perfil.fecha_creacion_cuenta,
        });
      } catch {
        setErrorMessage("No se pudieron cargar los datos del perfil.");
        setTimeout(() => navigate("/login"), 3000);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, [navigate]);

  const handleBack = () => navigate("/dashboard");
  const handleEdit = () => navigate("/perfil/editar");
  const handleTrainerClick = () =>
    userData.entrenador
      ? navigate(`/entrenadores?id=${userData.entrenador.id}`)
      : navigate("/entrenadores");
  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/login");
    } catch {
      setErrorMessage("Hubo un error al cerrar sesión.");
    }
  };

  const handleChangePhoto = () => {
    setShowAvatarOptions(false);
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setIsCropModalOpen(true);
    };
    reader.readAsDataURL(file);
  };

  const handleCropped = (croppedFile) => {
    const fd = new FormData();
    fd.append("foto", croppedFile);
    updateUserPhoto(fd)
      .then(() => setSuccessMessage("Tu foto se ha actualizado correctamente."))
      .catch(() => setErrorMessage("Error al actualizar la foto."));
    setIsCropModalOpen(false);
    setImageSrc(null);
  };

  if (loading) return <LoadingScreen />;

  const fechaCreacion = userData.fecha_creacion_cuenta
    ? new Date(userData.fecha_creacion_cuenta)
    : null;
  const fechaFormateada =
    fechaCreacion && !isNaN(fechaCreacion)
      ? fechaCreacion
          .toLocaleDateString("es-ES", { month: "short", year: "numeric" })
          .replace(/^(.)(.*)$/, (m, f, r) => f.toUpperCase() + r)
      : "";

  return (
    <div className="perfil-deportista">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {errorMessage && (
        <CuadroTexto
          message={errorMessage}
          onAccept={() => setErrorMessage("")}
          showCancel={false}
        />
      )}
      {successMessage && (
        <CuadroTexto
          message={successMessage}
          onAccept={() => {
            setSuccessMessage("");
            window.location.reload();
          }}
          showCancel={false}
        />
      )}

      <div className="perfil-header-section">
        <button className="back-button" onClick={handleBack}>
          <img src={backIcon} alt="Volver" />
        </button>
        <h2 className="perfil-title">Perfil</h2>
        <img
          src={settingsIcon}
          alt="Ajustes"
          className="settings-icon"
          onClick={handleEdit}
        />
      </div>

      <div className="perfil-content-section">
        <div className="perfil-info">
          <div
            className={`perfil-avatar-placeholder ${
              !userData.foto || userData.foto.includes("default")
                ? "without-photo"
                : "with-photo"
            }`}
          >
            <img
              src={
                !userData.foto || userData.foto.includes("default")
                  ? profilePlaceHolder
                  : `${userData.foto}?t=${new Date().getTime()}`
              }
              alt="profilePlaceHolder"
              className="perfil-avatar-holder"
              onClick={() => setShowAvatarOptions(true)}
            />
          </div>
          <h3 className="perfil-name">
            {userData.nombre} {userData.apellido}
          </h3>
          <p className="perfil-subtitle">
            <img src={improov} alt="improov" />{" "}
            <img src={miniCalendar} alt="miniCalendar" /> {fechaFormateada}
          </p>
        </div>

        <div className="social-row">
          <div className="social-container">
            <img
              src={instagramIconGrey}
              alt="Instagram"
              className="instagram-icon"
            />
            <input
              type="text"
              placeholder="Agregar tu Instagram"
              className="social-input"
              value={userData.instagram}
              readOnly
            />
          </div>
          <div className="social-container">
            <input
              type="text"
              placeholder="Número celular"
              className="social-input"
              value={userData.celular}
              readOnly
            />
          </div>
        </div>

        <div className="perfil-field">
          <label className="perfil-label">Mi objetivo:</label>
          <button
            className="perfil-objective-button"
            onClick={() => navigate("/objetivo")}
            style={{ color: userData.objetivo ? "white" : "#626262" }}
          >
            {userData.objetivo || "Definir objetivo"}
          </button>
        </div>

        <div className="perfil-field">
          <label className="perfil-label">Entrenador actual:</label>
          <button
            className="trainer-button"
            onClick={handleTrainerClick}
            style={{ color: userData.entrenador ? "white" : "#626262" }}
          >
            {userData.entrenador
              ? `${userData.entrenador.nombre} ${userData.entrenador.apellido}`
              : "Buscar entrenador"}{" "}
            <img src={forward} alt="forward" />
          </button>
        </div>

        <button className="logout-button" onClick={handleLogout}>
          Cerrar sesión <img src={logoutIcon} alt="logOut" />
        </button>
      </div>

      {showAvatarOptions && (
        <CuadroTexto
          message="¿Qué deseas hacer con tu foto de perfil?"
          acceptText="Cambiar foto"
          cancelText="Ver foto"
          acceptClassName="btn change-btn"
          cancelClassName="btn view-btn"
          onAccept={handleChangePhoto}
          onCancel={() => {
            setShowAvatarOptions(false);
            setViewImageModal(true);
          }}
          showCancel={true}
        />
      )}

      {viewImageModal && (
        <div
          className="crop-modal-overlay"
          onClick={() => setViewImageModal(false)}
        >
          <div className="crop-modal" onClick={(e) => e.stopPropagation()}>
            <img
              src={userData.foto || profilePlaceHolder}
              alt="Foto completa"
              style={{ maxWidth: "100%", maxHeight: "80vh" }}
            />
            <button
              className="crop-cancel-btn"
              onClick={() => setViewImageModal(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

      {isCropModalOpen && imageSrc && (
        <div
          className="crop-modal-overlay"
          onClick={() => setIsCropModalOpen(false)}
        >
          <div className="crop-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Recortar Imagen</h3>
            <ImageCropper
              src={imageSrc}
              onCropped={handleCropped}
              onCancel={() => setIsCropModalOpen(false)}
            />
          </div>
        </div>
      )}

      <Footer activeScreen="perfil" />
    </div>
  );
};

export default Perfil;
